import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";

export default function WaitListTable({ list }) {
  return (
    <TableContainer
      elevation={0}
      component={Paper}
      sx={{ maxHeight: 350, height: "25vh", border: " 1px solid #c4c4c4" }}
    >
      <Table
        stickyHeader
        size="small"
      >
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold", p: 0, bgcolor: "var(--light-grey)" }}
            >
              Danh sách mã chờ xử lý ({list?.length})
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(list) && list?.length > 0 ? (
            <>
              {list?.map((v) => (
                <Item
                  key={v.id}
                  item={v}
                />
              ))}
            </>
          ) : (
            <></>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const Item = ({ item }) => {
  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell align="center">{item}</TableCell>
    </TableRow>
  );
};
